import React from 'react';
import { makeStyles, Paper, Typography } from '@material-ui/core';
import alertIcon from '../../static/images/alert.png';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#E0F3F3',
    borderRadius: '1rem',
    display: 'flex',
    padding: '1rem',
    alignItems: 'center',
  },
  alertIcon: {
    width: '1rem',
    height: '1rem',
  },
  typography: {
    fontSize: '0.5rem',
    fontWeight: '800',
    paddingLeft: '1rem',
  },
}));

export default function OperrationAlert() {
  const classes = useStyles();
  return (
    <Paper className={classes.root} elevation={0}>
      <img src={alertIcon} className={classes.alertIcon} alt="" />
      <Typography className={classes.typography}>
        operation alertl Lorem Ipsum is simply dummy text of the printing and typesetting industry.
      </Typography>
    </Paper>
  );
}
